import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    workInstruction: {
        textAlign: 'left',
        padding: '14px'
    }
});

export default function ScheduleSummaryDetailJobInstruction(props) {
    const classes = useStyles();

    const [workInstruction, setWorkInstruction] = React.useState('');

    const { data } = props;

    useEffect(() => {
        setWorkInstruction(data.workInstructions);
    }, []);

    return (
        <div className={classes.workInstruction}>
            <span style={{ whiteSpace: "pre-wrap" }}>
                {workInstruction}
            </span>
        </div>
    );
}